/**
 * @license Angular v19.2.3
 * (c) 2010-2025 Google LLC. https://angular.io/
 * License: MIT
 */

function setAlternateWeakRefImpl(impl) {
    // TODO: remove this function
}

export { setAlternateWeakRefImpl as s };
